module.exports = __webpack_public_path__ + "static/media/logo.b14ba91c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 28
// module chunks = 1